onReady(($) => {
    $('.featured-series')
        .each((index, module) => {
            let $module = $(module)
            $('.posts-column', $module)
                .slick({
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: true,
                    prevArrow: $(".slick-prev", $module),
                    nextArrow: $(".slick-next", $module),
                    fade: false,
                    responsive: [
                        {
                            breakpoint: 564,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            $module.hover(function () {
                $('.slick-next, .slick-prev', $module)
                    .toggleClass("chevron-visible");
            });
        });
    const featuredSeriess = Array.from(document.querySelectorAll('.featured-series'))
    for (const featuredSeries of featuredSeriess) {
        const ctaButton = featuredSeries.querySelector('.cta-button')
        ctaButton && ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, ctaButton, featuredSeries));
    }
});
